let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9Y8tZ")).then(() => parcelRequire('dsm1a'));